import {
	Box,
	Button,
	ButtonGroup,
	Container,
	HStack,
	Icon,
	Input,
	InputGroup,
	InputLeftElement,
	Stack,
	Text,
	useBreakpointValue,
} from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import { MemberTable } from './MemberTable'

export const TableComponent = () => {
	const isMobile = useBreakpointValue({
		base: true,
		md: false,
	})

	const members = [
		{
			id: '1',
			name: 'Christian Nwamba',
			handle: '@christian',
			email: 'christian@chakra-ui.com',
			avatarUrl: 'https://bit.ly/code-beast',
			status: 'active',
			role: 'Senior Developer Advocate',
			rating: 4,
		},
		{
			id: '2',
			name: 'Kent C. Dodds',
			handle: '@kent',
			email: 'kent@chakra-ui.com',
			avatarUrl: 'https://bit.ly/kent-c-dodds',
			status: 'active',
			role: 'Director of DX',
			rating: 4,
		},
		{
			id: '3',
			name: 'Prosper Otemuyiwa',
			handle: '@prosper',
			email: 'prosper@chakra-ui.com',
			avatarUrl: 'https://bit.ly/prosper-baba',
			status: 'active',
			role: 'Director of Evangelism',
			rating: 4,
		},
		{
			id: '4',
			name: 'Ryan Florence',
			handle: '@ryan',
			email: 'ryan@chakra-ui.com',
			avatarUrl: 'https://bit.ly/ryan-florence',
			status: 'active',
			role: 'Co-Founder',
			rating: 4,
		},
		{
			id: '5',
			name: 'Segun Adebayo',
			handle: '@segun',
			email: 'segun@chakra-ui.com',
			avatarUrl: 'https://bit.ly/sage-adebayo',
			status: 'active',
			role: 'Frontend UI Engineer',
			rating: 4,
		},
	]

	return (
		<Container
			py={{
				base: '4',
				md: '8',
			}}
			px={{
				base: '0',
				md: 4,
			}}
			maxW='7xl'
		>
			<Box
				bg="bg-surface"
				boxShadow={{
					base: 'none',
					md: 'sm',
				}}
				borderRadius={{
					base: 'none',
					md: 'lg',
				}}
			>
				<Stack spacing="5">
					<Box
						px={{
							base: '4',
							md: '6',
						}}
						pt="5"
					>
						<Stack
							direction={{
								base: 'column',
								md: 'row',
							}}
							justify="space-between"
						>
							<Text fontSize="lg" fontWeight="medium">
								Members
							</Text>
							<InputGroup maxW="xs">
								<InputLeftElement pointerEvents="none">
									<Icon as={FiSearch} color="muted" boxSize="5" />
								</InputLeftElement>
								<Input placeholder="Search" />
							</InputGroup>
						</Stack>
					</Box>
					<Box overflowX="auto">
						<MemberTable data={members} />
					</Box>
					<Box
						px={{
							base: '4',
							md: '6',
						}}
						pb="5"
					>
						<HStack spacing="3" justify="space-between">
							{!isMobile && (
								<Text color="muted" fontSize="sm">
									Showing 1 to 5 of 42 results
								</Text>
							)}
							<ButtonGroup
								spacing="3"
								justifyContent="space-between"
								width={{
									base: 'full',
									md: 'auto',
								}}
								variant="secondary"
							>
								<Button>Previous</Button>
								<Button>Next</Button>
							</ButtonGroup>
						</HStack>
					</Box>
				</Stack>
			</Box>
		</Container >
	)
}